import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledBox = styled(Box)({
  backgroundColor: "rgba(0,82,255,255)",
  height: "100vh",
});
